import { smartQueue } from '../utils/queue.js';
import '../app-config/app-config.js';
import '../app-config/boot-flags.js';
import '../app-config/build-data.js';
import { getTenantNamespace } from '../app-config/tenant.js';

const CHRONOSPHERE_LOGS_INGEST_ENDPOINT = '/api/unstable/data/logs/forward';
const CLOUD_UI_LOGGING_SERVICE = 'cloud-ui-browser';
/**
 * Client for sending logs to Chronosphere.
 * @TODO: This more or less adheres to the https://getanalytics.io/plugins/writing-plugins/
 * interface which is something we might want to consider using in the future.
 */ class ChronosphereLogsClient {
    constructor(url){
        this.url = url || CHRONOSPHERE_LOGS_INGEST_ENDPOINT;
        this.service = CLOUD_UI_LOGGING_SERVICE;
        this.identifyPayload = {};
        this._enabled = false;
        this._logQueue = smartQueue((events)=>{
            this._flushLogs(events);
        }, {
            max: 10,
            interval: 3000,
            throttle: true
        });
    }
    /**
   * Log a page view event.
   */ page() {
        if (this._lastPathname === window.location.pathname) {
            return;
        }
        const pathname = window.location.pathname;
        this.submitLog({
            message: '[page_view] ' + pathname,
            event_name: 'page_view'
        });
        this._lastPathname = pathname;
    }
    /**
   * Identify a user.
   */ identify(userId, payload) {
        this._enabled = true;
        this.identifyPayload = {
            user_id: userId,
            ...payload
        };
        // TODO: Remove email from logs if it's not a Chronosphere email until its safe to do so.
        if (typeof this.identifyPayload.email === 'string' && !this.identifyPayload.email.includes('@chronosphere.io')) {
            delete this.identifyPayload.email;
        }
        // Log page view once we have the user info
        this.page();
    }
    /**
   * Track an event.
   */ track(eventName, payload) {
        this.submitLog({
            message: '[event] ' + eventName,
            event_name: eventName,
            ...payload
        });
    }
    /**
   * Submit a log event to the server. Batches the event with other logs.
   */ submitLog(log) {
        const tenantName = getTenantNamespace();
        const payload = {
            happened_at: new Date().toISOString(),
            ...log,
            ...this.identifyPayload,
            ...this._getPageInfo(),
            'resource.type': 'browser',
            // @chao mentioned we should dual write this field since we optimize the index on this.
            'resource.labels.namespace_name': tenantName,
            tenant_name: tenantName,
            service: this.service,
            level: log.level ?? 'info'
        };
        this._logQueue.push(payload);
    }
    /**
   * Flush a list of logs to the server.
   */ _flushLogs(logs) {
        // Don't send logs if we're not enabled
        if (!this._enabled || process.env.NODE_ENV === 'development') {
            return;
        }
        const payload = logs.map((e)=>JSON.stringify(e)).join('\n');
        try {
            fetch(this.url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: payload
            });
        } catch (e) {
            console.error('Failed to send logs to Chronosphere', e);
        }
    }
    /**
   * Get information about the current page.
   */ _getPageInfo() {
        return {
            page_title: document.title,
            page_url: window.location.href
        };
    }
}
const chronosphereLogsClient = new ChronosphereLogsClient();

export { CHRONOSPHERE_LOGS_INGEST_ENDPOINT, CLOUD_UI_LOGGING_SERVICE, ChronosphereLogsClient, chronosphereLogsClient };
//# sourceMappingURL=chronosphere-logs.js.map
